import { render } from "./FullLayout.vue?vue&type=template&id=24ae8cb5&scoped=true"
const script = {}

import "./FullLayout.vue?vue&type=style&index=0&id=24ae8cb5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ae8cb5"]])

export default __exports__